import React, { createContext, useContext, useReducer } from "react";
import { ACTION_TYPES, RepassesSetoriaisReducer, RepassesSetoriaisState } from "./repasses-setoriais-reducer";
import { PaginationResponse } from "models/pagination-response";
import { IRepasseSetorialPagedResponse } from "models/response/repasse-setorial-paged-response";

const RepassesSetoriaisContext = createContext<RepassesSetoriaisState | undefined>(undefined);
const RepassesSetoriaisContextDispatchContext = createContext({} as any);

const RepassesSetoriaisProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(RepassesSetoriaisReducer, {
        repasses: new PaginationResponse<IRepasseSetorialPagedResponse>([], 0, 1, 10, 0),
        repassePagedRequest: { page: 0, pageSize: 10 },
        areas: [],
        origens: [],
        ultimaAtualizacao: null,
        totais: { valorTotalPrevisto: 0, valorTotalRealizado: 0 },
        loading: false,
        error: null
    } as RepassesSetoriaisState);

    return (
        <RepassesSetoriaisContext.Provider value={state}>
            <RepassesSetoriaisContextDispatchContext.Provider value={dispatch}>
                {children}
            </RepassesSetoriaisContextDispatchContext.Provider>
        </RepassesSetoriaisContext.Provider>
    );
}

const useRepassesSetoriaisState = () => {
    const context = useContext(RepassesSetoriaisContext);
    if (context === undefined) {
        throw new Error('useRepassesSetoriaisState must be used within a RepassesSetoriaisProvider');
    }
    return context;
}

const useRepassesSetoriaisDispatch = () => {
    const context = useContext(RepassesSetoriaisContextDispatchContext);
    if (context === undefined) {
        throw new Error('useRepassesSetoriaisDispatch must be used within a RepassesSetoriaisProvider');
    }
    return context;
}

export { RepassesSetoriaisProvider, useRepassesSetoriaisState, useRepassesSetoriaisDispatch, ACTION_TYPES };
